import $ from 'jquery';

// Share on desktop
$(function () {
  $(document).on('click', '#copy-paste-button', function() {
    let url = $('#copy-btn-url').val();
    let messageSuccess = $('.share-copied-success');

    navigator.clipboard.writeText(url);
    messageSuccess.css('display', 'block');

    // Hide msg after 2s
    setTimeout(function () {
      messageSuccess.css('display', 'none');
    }, 2500);
  });
});

// Share on mobile
window.addEventListener('load', () => {
  const h1 = document.querySelector('h1');
  const title_to_share = h1 ? h1.textContent : '';

  const shareData = {
    title: title_to_share,
    url: window.location.href,
  };

  const button = document.querySelector('#shareButton');

  if(button) {
    button.addEventListener('click', () => {
      navigator.share(shareData).then(() => {});
    });
  }
});
